import { z } from 'zod';

export const AGENT_MESSAGE_MAX_LENGTH = 2000;

export const cmsAgentRequestSchema = z.object({
    conversationId: z.string().min(1).optional(),
    message: z.string().min(1).max(AGENT_MESSAGE_MAX_LENGTH),
});

export const agentMessageSchema = z.discriminatedUnion('role', [
    z.object({ role: z.literal('user'), content: z.string().min(1) }),
    z.object({
        role: z.literal('assistant'),
        content: z.string(),
        calls: z.array(z.string().min(1)),
    }),
]);

export const agentRequestSchema = z.object({
    conversationId: z.string().min(1),
    requestId: z.string().min(1),
    messages: z
        .array(agentMessageSchema)
        .min(1)
        .refine((messages) => messages[messages.length - 1]?.role === 'user', {
            message: 'the last message must be the new user question',
        })
        .describe('The last message is the new user question.'),
});

export type CmsAgentRequest = z.infer<typeof cmsAgentRequestSchema>;
export type AgentMessage = z.infer<typeof agentMessageSchema>;
export type AgentRequest = z.infer<typeof agentRequestSchema>;
